import { Menu, Layout, Drawer } from "antd";
import React, { useEffect, useState } from "react";
import AppLogo from "../assets/images/foxtox-logo-new.png";
import { AUTHENTICATED_ROUTES, ROUTES } from "../constants/routeConstants";
import { useLocation, NavLink } from "react-router-dom";

const { Sider } = Layout;

const Sidebar = ({ mobileOpen, onMobileClose }) => {
  const ADMIN_ROUTE = ROUTES.ADMIN;
  const { pathname } = useLocation();

  const [clickedItem, setClickedItem] = useState("");
  const [isExpanded, setIsExpanded] = useState(false);

  const handleClick = (key) => {
    setClickedItem(key);
    if (onMobileClose) {
      onMobileClose();
    }
  };

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 100) {
        setIsExpanded(true);
        // console.log(window.scrollY)
      } else {
        setIsExpanded(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const sidebarContent = (
    <>
      <div className="siderbar-header flex justify-center items-center py-4 lg:py-6">
        <img
          src={AppLogo}
          alt="App logo"
          className="w-16 h-16 lg:w-18 lg:h-18"
        />
      </div>

      <Menu mode="vertical" selectedKeys={[clickedItem]} className="border-0">
        {ADMIN_ROUTE.map((item, index) => {
          return (
            <Menu.Item
              key={item?.route}
              className={
                clickedItem === item?.route
                  ? "active-menu-item"
                  : pathname == item?.route && "active-menu-item"
              }
            >
              <NavLink
                to={item?.route}
                onClick={() => handleClick(item?.route)}
                key={item.route}
                className="block relative"
              >
                {item?.route == pathname && (
                  <div className="active-indicator absolute left-0 top-0 bottom-0 w-1.5 h-14 rounded-r-lg bg-primary"></div>
                )}
                <div className="sidebar_label flex items-center gap-3 lg:gap-4 px-6 ">
                  <div className="flex-shrink-0">
                    <img
                      src={
                        item?.route == pathname
                          ? item?.selectedIcon
                          : item?.unSelectedIcon
                      }
                      alt="icon"
                      className="w-6 h-6"
                    />
                  </div>
                  <div className="flex-1">
                    <p
                      className={
                        pathname === item?.route
                          ? "active-menu-label text-base font-bold text-primary m-0"
                          : "inactive-menu-label text-base font-semibold text-gray-500 m-0"
                      }
                    >
                      {item?.label}
                    </p>
                  </div>
                </div>
              </NavLink>
            </Menu.Item>
          );
        })}
      </Menu>
    </>
  );

  return (
    <>
      <Sider
        collapsedWidth="0"
        trigger={null}
        width={250}
        className={`sidebar ${isExpanded ? "expanded" : ""}`}
      >
        {sidebarContent}
      </Sider>
     
      <Drawer
        placement="left"
        onClose={onMobileClose}
        open={mobileOpen}
        className="xl:hidden"
        width={280}
        styles={{
          body: { padding: 0 },
        }}
      >
        {sidebarContent}
      </Drawer>
    </>
  );
};

export default Sidebar;
